module.exports = __webpack_public_path__ + "static/media/lingmingshanadj.aa5a59de.png";